<template>
  <div>
    <div class="navless-layout-header">
      <slot name='navbar'>
        <ed-button :to='$routerHistory.previous().path'>
          <i class="fal fa-chevron-left"></i>
          &nbsp;
          Back
        </ed-button>
      </slot>
    </div>
    <div>
      <p style="color:white; margin:0px; height:27px;">t</p>
    </div>
    <div :endpoint='api.$.evedpaycard.cards'>
      <div v-if="cards" class="content" :key="cards.id">
        <div>
          <p class="card-details-text">Card Details</p>
        </div>
        <div class="card-preview-container">
          <div class="card-preview">
            <img src='https://d1a4bxjw35af21.cloudfront.net/images_en/eved-pay-logo.svg' alt='EvedPay Logo'>
            <div class="col-md-6 static">
              <p class="card-number">•••• •••• •••• {{ cards.cardNumber }}</p>
            </div>
            <div class="col-md-6 card-details-row2">
              <div class="col-md-3 static">
                <p class="card-expiry">
                  <span class="small"><small>VALID THRU</small></span>
                  <br />
                  ••/••
                </p>
              </div>
              <div class="col-md-3 static">
                <p class="card-ccv">
                  <span class="small"><small>CVV</small></span>
                  <br />
                  •••
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="cards.cardStatus === 'Active'" class="button-container">
          <button v-if="isCardHolder" class="btn btn-sm custom-button" @click="() => redirectToShowNumber(cards)">CARD NUMBER</button>
          <button v-if="!cards.isPhysicalCard" class="btn btn-sm custom-button" @click="() => redirectToRequestCard(cards)">REQUEST PHYSICAL CARD</button>
          <button v-if="cards.pending === 0" class="btn btn-sm custom-button" @click="() => redirectToAddFunds(cards)">{{ isUserAdmin ? 'ADD FUNDS' : 'REQUEST ADDITIONAL FUNDS' }}</button>
          <button class="btn btn-sm custom-button" @click="() => redirectToChangePin(cards)">CHANGE PIN</button>
        </div>
        <!--  <div class="card">
          <ed-notice>
            <div class="col-xs-9">
              <p class="no-margin text-left"><strong>Add to digital wallets.</strong></p>
            </div>
            <div class="col-xs-3 text-right">
              <i class='open icon fas fa-angle-right'></i>
            </div>
          </ed-notice>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus'
export default {
  alias: 'evedpaycarddetails',
  data() {
    return {
      cardId: this.$route.query.cardid,
      cards: null
    }
  },
  created() {
    const CardId = this.$route.query.cardid
    this.api.forms.post(this.api.$.evedpaycard.cards, {
      sort: 'CardNumber',
      dir: 'DESC',
      start: 0,
      limit: 100,
      isLiveGrid: true,
      filter: {
        CardStatus: 'active',
        searchTerm: ''
      }
    }).then(r => {
      const matchedCard = r.data.Data.find(card => card.Id === CardId)
      if (matchedCard) {
        this.cards = {
          name: matchedCard.Name || `EvedPay Card ...${matchedCard.CardNumber}`,
          holder: matchedCard.Holder,
          holderUserId: matchedCard.HolderUserId,
          id: matchedCard.Id,
          cardNumber: matchedCard.CardNumber,
          divisionId: matchedCard.DivisionId,
          isPhysicalCard: matchedCard.IsPhysicalCard,
          cardStatus: matchedCard.CardStatus,
          accountBalance: matchedCard.AccountBalance,
          pending: matchedCard.Pending
        }
      }
    })
    EventBus.$off('pin-changed')
    EventBus.$on('pin-changed', () => {
      this.$notifications.notify({
        message: `Pin has been changed successfully!`,
        type: 'info',
        placement: { from: 'top', align: 'center' }
      })
    })
    EventBus.$off('fundsAdded')
    EventBus.$on('fundsAdded', () => {
      this.$notifications.notify({
        message: `Request sent successfully!`,
        type: 'info',
        placement: { from: 'top', align: 'center' }
      })
    })
  },
  computed: {
    isCardHolder() {
      return this.cards && this.$user.$.user.UserID === this.cards.holderUserId
    },
    isUserAdmin() {
      if (this.$user.$.userPermissions.includes('EvedPayCardAdministrator')) {
        return true
      }
      return false
    }
  },
  methods: {
    redirectToRequestCard(card) {
      this.$router.push({
        path: `/evedpay/requestcard?cardid=${card.id}`,
        query: {
          divisionId: card.divisionId,
          ...this.$route.query
        }
      })
    },
    redirectToChangePin(card) {
      this.$router.push({
        path: `/evedpay/changepin?cardid=${card.id}`,
        query: {
          ...this.$route.query
        }
      })
    },
    redirectToShowNumber(card) {
      this.$router.push({
        path: `/evedpay/shownumber?cardid=${card.id}`,
        query: {
          ...this.$route.query
        }
      })
    },
    redirectToAddFunds(card) {
      this.$router.push({
        path: `/evedpay/loadfunds?cardid=${card.id}`,
        query: {
          accBalance: card.accountBalance,
          ...this.$route.query
        }
      })
    }
  }
}

</script>

<style lang='scss' scoped>
@import "~@/assets/sass/_variables.scss";

  .content {
    text-align: center;
  }

  .card-preview-container {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }

  .card {
    width: 85%;
    margin: 0 auto;
  }

  .card-preview {
    background: linear-gradient(315deg, #8C407B 0%, #63417E 100%);
    border-radius: 7px;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    position: relative;
    height: auto;

    width: 312px;
    height: 197px;
    position: relative;

    img {
      height: auto;
      width: 45%;
      position: absolute;
      top: 20px;
      right: 20px;
    }

    p {
      color: #FFFFFF;
      font-size: 17px;
      margin-top: 20px;
      text-align: center;
      z-index: 1;
      position: absolute;
      bottom: 10px;
      left: 28px;
      margin: 0;
      text-shadow: 1px 1px 2px #000000;
      letter-spacing: 0.06em;
      position: absolute;
    }
    .card-number {
      bottom: 60px;
    }
    .card-details-row2 {
      display: flex;
      position: absolute;
      left: 0;
      bottom: 10px;
      p {
        position: static;
        display: inline-block;
      }
    }
    .static {
      position: static;
    }
  }

.card-details-text {
  text-align: left;
  padding-left: 20px;
  margin-bottom: 10px;
  width: 80%;
}

.button-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  .text-center {
    text-align: center;
  }

  .custom-button {
    background-color: #fff;
    color: #007bff;
    border: 1px solid #007bff;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 85%;
    margin: 0 auto;
  }

  .custom-button:hover {
    background-color: #007bff;
    color: #fff;
  }

  .card {
    border-radius: 6px;
    border-top-width: 0px !important;
    border-right-width: 0px !important;
    border-bottom-width: 0px !important;
    box-shadow: 1px 3px 5px 0px rgba(0,0,0,0.15);
    width: 80%;
    margin: 0 auto;

    >>> &.no-icon .icon-wrapper.no-icon {
      min-width: 0;
    }
  }

  .p1 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_modules/EvedPay/details.vue